import React from 'react';
import { getOpportunityStats } from '../../services/opportunityService';

const Tile = ({ label, value, hint, accent }) => (
  <div className="bg-card border border-line rounded-card px-3.5 py-3 min-w-0">
    <div className="text-[11px] font-semibold uppercase tracking-wide text-muted truncate">{label}</div>
    <div className={`mt-0.5 text-[22px] font-bold tabular leading-tight ${accent ? 'text-accent' : 'text-primary'}`}>{value}</div>
    {hint && <div className="text-xs text-secondary truncate">{hint}</div>}
  </div>
);

export default function OpportunityStats({ opportunities }) {
  const stats = getOpportunityStats(opportunities);
  
  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3">
      <Tile label="Active" value={stats.active} hint={`${stats.total} total`} accent />
      <Tile label="Avg discount" value={`${stats.avgDiscount}%`} hint={`${stats.tracked} tracked`} />
      <Tile label="Avg score" value={`${stats.avgScore}/10`} hint={`${stats.dismissed} dismissed`} />
    </div>
  );
}
